/**
 * Engraving toggle — black-framed panel (chip + textarea) matching seal /
 * two-tone treatment. Thinkspace checkbox is mislabelled data-option="Two-tone".
 *
 * Depends on: sj-3d-builder.js, sj-image-stepper.css, sj-metal-chips.css
 */
(function () {
  'use strict';

  var B = window.Sj3dBuilder;
  if (!B) return;

  var READY = 'data-sj-engraving-chip-ready';
  var HOST = 'sj-engraving-host';
  var PANEL = 'sj-engraving-panel';

  function isEngravingField(field) {
    var label = field && field.querySelector('label');
    var text = String(
      (label && label.textContent) || (field && field.textContent) || ''
    ).toLowerCase();
    return text.includes('engrav');
  }

  function findEngravingFields() {
    return Array.prototype.filter.call(
      document.querySelectorAll('[data-option="Two-tone"]'),
      isEngravingField
    );
  }

  function getCheckbox(field) {
    return field ? field.querySelector('input[type="checkbox"]') : null;
  }

  /** Outer Thinkspace grid that holds the toggle + textarea. */
  function getPanel(field) {
    var wrap = field && field.parentElement;
    return wrap && wrap.parentElement ? wrap.parentElement : null;
  }

  function getTextarea(panel) {
    return panel ? panel.querySelector('textarea') : null;
  }

  function getInputWrapper(panel) {
    if (!panel) return null;
    return (
      panel.querySelector('.contact-form__input-wrapper') ||
      (getTextarea(panel) && getTextarea(panel).parentElement) ||
      null
    );
  }

  function linesUsed(textarea) {
    if (!textarea) return 0;
    return String(textarea.value || '')
      .split('\n')
      .filter(Boolean).length;
  }

  function priceLabel(field) {
    var label = field && field.querySelector('label');
    var text = String((label && label.textContent) || '');
    var live = text.match(/\+\s*\$?\s*[\d,]+(?:\.\d{2})?/);
    if (live) return live[0].replace(/\s+/g, '');
    try {
      var data =
        (B && typeof B.catalogData === 'function' && B.catalogData()) || null;
      var raw = data && data.addons_pricing && data.addons_pricing.engraving;
      var n = Number(raw);
      if (Number.isFinite(n) && n > 0) {
        return '+$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
      }
    } catch (_) {
      /* ignore */
    }
    return '';
  }

  function ensureMount(field) {
    var mount = field.querySelector('[data-sj-engraving-chip]');
    if (!mount) {
      mount = document.createElement('div');
      mount.setAttribute('data-sj-engraving-chip', '');
      field.appendChild(mount);
    }
    return mount;
  }

  function hideNativeToggle(field) {
    field.querySelectorAll('label, input[type="checkbox"]').forEach(function (el) {
      el.classList.add('sj-engraving-native');
    });
  }

  function hideNativeHelpers(panel) {
    if (!panel) return;
    panel.querySelectorAll('.tw\\:text-xs, [class*="text-xs"]').forEach(function (el) {
      if (el.hasAttribute('data-sj-engraving-meta')) return;
      var t = String(el.textContent || '').toLowerCase();
      if (
        t.includes('lines max') ||
        t.includes('characters per line') ||
        t.includes('lines used')
      ) {
        el.classList.add('sj-engraving-helper-native');
      }
    });
  }

  function ensureMetaLine(wrapper) {
    if (!wrapper) return null;
    var meta = wrapper.querySelector('[data-sj-engraving-meta]');
    if (!meta) {
      meta = document.createElement('div');
      meta.setAttribute('data-sj-engraving-meta', '');
      meta.className = 'sj-engraving-meta';
      var ta = wrapper.querySelector('textarea');
      if (ta) wrapper.insertBefore(meta, ta);
      else wrapper.appendChild(meta);
    }
    return meta;
  }

  function updateMetaLine(panel) {
    var wrapper = getInputWrapper(panel);
    var ta = getTextarea(panel);
    if (!wrapper || !ta) return;
    hideNativeHelpers(panel);
    var meta = ensureMetaLine(wrapper);
    if (!meta) return;
    var used = linesUsed(ta);
    meta.textContent = '3 lines — 4 characters — ' + used + ' / 3 lines used';
  }

  function chipStateKey(field, panel) {
    var cb = getCheckbox(field);
    if (!cb) return '';
    return (
      (cb.checked ? '1' : '0') +
      '|' +
      (cb.disabled ? '1' : '0') +
      '|' +
      priceLabel(field)
    );
  }

  function buildSubtitle(on, price) {
    if (!on) return 'Your finishing touch';
    if (price) return 'Your finishing touch · ' + price;
    return 'Your finishing touch';
  }

  function renderChip(field) {
    var cb = getCheckbox(field);
    if (!cb) return;
    if (field._sjEngravingRendering) return;

    var panel = getPanel(field);
    var key = chipStateKey(field, panel);
    if (field._sjEngravingKey === key && field.querySelector('[data-sj-engraving-chip] button')) {
      field.classList.remove('sj-seal-size-absorbed');
      if (panel) {
        panel.classList.add(PANEL);
        panel.classList.toggle('is-open', Boolean(cb.checked));
        if (cb.checked) updateMetaLine(panel);
      }
      return;
    }

    field._sjEngravingRendering = true;
    try {
      hideNativeToggle(field);
      field.classList.add(HOST);
      field.classList.remove('sj-seal-size-absorbed');
      if (panel) {
        panel.classList.add(PANEL);
        panel.classList.toggle('is-open', Boolean(cb.checked));
        hideNativeHelpers(panel);
        if (cb.checked) updateMetaLine(panel);
      }

      var on = Boolean(cb.checked);
      var price = priceLabel(field);
      var mount = ensureMount(field);
      var subtitle = buildSubtitle(on, price);

      var wrap = document.createElement('div');
      wrap.className = 'sj-seal-size-chips sj-engraving-chips';
      wrap.setAttribute('role', 'group');
      wrap.setAttribute('aria-label', 'Engraving');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'sj-seal-size-chip sj-seal-size-chip--two-tone sj-engraving-chip';
      btn.classList.toggle('is-selected', on);
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute(
        'aria-label',
        on
          ? 'Add engraving: On' + (price ? ', ' + price : '') + '. Tap to turn off.'
          : 'Add engraving: Off. Tap to turn on.'
      );
      btn.innerHTML =
        '<span class="sj-seal-size-chip__text">' +
        '<span class="sj-seal-size-chip__title">Add Engraving</span>' +
        '<span class="sj-seal-size-chip__subtitle">' +
        subtitle +
        '</span>' +
        '</span>';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (cb.disabled) return;
        field._sjEngravingKey = '';
        cb.click();
        window.setTimeout(function () {
          renderChip(field);
          wireTextarea(field);
        }, 0);
      });

      wrap.appendChild(btn);
      mount.replaceChildren(wrap);
      field._sjEngravingKey = key;
      wireTextarea(field);
    } finally {
      field._sjEngravingRendering = false;
    }
  }

  function wireTextarea(field) {
    var panel = getPanel(field);
    var ta = getTextarea(panel);
    if (!ta || ta._sjEngravingInputBound) {
      if (panel) updateMetaLine(panel);
      return;
    }
    ta._sjEngravingInputBound = true;
    var sync = function () {
      updateMetaLine(panel);
    };
    ta.addEventListener('input', sync);
    ta.addEventListener('change', sync);
    updateMetaLine(panel);
  }

  function enhanceField(field) {
    if (!field || !getCheckbox(field)) return;

    if (field.getAttribute(READY) === '1') {
      renderChip(field);
      wireTextarea(field);
      return;
    }

    field.setAttribute(READY, '1');
    field.classList.remove('sj-seal-size-absorbed');
    renderChip(field);
    wireTextarea(field);

    var cb = getCheckbox(field);
    if (cb && !cb._sjEngravingChangeBound) {
      cb._sjEngravingChangeBound = true;
      cb.addEventListener('change', function () {
        field._sjEngravingKey = '';
        renderChip(field);
        wireTextarea(field);
      });
    }
  }

  function scan() {
    findEngravingFields().forEach(enhanceField);
  }

  B.bootOnWidget(function (widget) {
    B.watchWidget(widget, scan);
  });
})();
